<template>
  <CRow style="margin-top: 30px">
    <template>
      <CCol md="2" sm="6">
      </CCol>
         <CCol md="4" sm="6">
             
      </CCol>
         <CCol md="6" sm="6">
 <CButton  @click="refresh()" style="float:left"><i class="fa fa-refresh" aria-hidden="true"></i> Refresh</CButton>
           &nbsp;&nbsp;&nbsp;<h4 style="text-align:center">Last update: {{ this.datadisplay.time }}</h4>
        
           <i class="fa fa-sign-out" aria-hidden="true" @click="deleteRoute()" style="font-size: x-large;float:right;margin-top: -28px;"></i>
      </CCol>
      <CCol md="4" sm="6">
        <h4><b> User Details</b></h4>
        <CWidgetBrand
          color="facebook"
          :right-header="this.datadisplay.yesterdayusercount"
          :right-footer="this.yesterdaydate"
          :left-header="this.datadisplay.todayusercount"
          :left-footer="this.todaydate"
        >
          <div class="h4 m-0" style="text-align: center">
            {{ this.datadisplay.totalusercount }}

            <br />Total Registrations
          </div>

          <CIcon
            name="cil-userFollow"
            height="52"
            class="my-4"
            style="padding-left: 30px"
          />
        </CWidgetBrand>
      </CCol>
      <CCol md="4" sm="6">
        <h4><b> Game Details</b></h4>
        <CWidgetBrand
          color="twitter"
          :right-header="this.datadisplay.yesterdaygamecount"
          :right-footer="this.yesterdaydate"
          :left-header="this.datadisplay.todaygamecount"
          :left-footer="this.todaydate"
        >
          <div class="h4 m-0" style="text-align: center">
            {{ this.datadisplay.totalgamecount }}

            <br />Total Game Entry
          </div>

          <CIcon
            name="cil-userFollow"
            height="52"
            class="my-4"
            style="padding-left: 30px"
          />
        </CWidgetBrand>
      </CCol>
      <CCol md="4" sm="6">
        <h4><b> Login Details</b></h4>
        <CWidgetBrand
          color="success"
          right-header="0"
          :right-footer="this.yesterdaydate"
          left-header="0"
          :left-footer="this.todaydate"
        >
          <div class="h4 m-0" style="text-align: center">
          0

            <br />
            Logged User Details
          </div>
          <CIcon
            name="cil-cursor"
            height="52"
            class="my-4"
            style="padding-left: 30px"
          />
        </CWidgetBrand>
      </CCol>
      <!-- <CCol md="4" sm="6">
        <h4><b> NFT Capture Details</b></h4>
        <CWidgetBrand
          :right-header="this.yesterdayNFT"
          :right-footer="this.yesterdaydate"
          :left-header="this.todayNFT"
          :left-footer="this.todaydate"
          color="gradient-warning"
        >
          <div class="h4 m-0" style="text-align: center">
            {{ this.totalNFT }}

            <br />
            NFT Capture
          </div>
          <CIcon
            name="cil-calendar"
            height="52"
            class="my-4"
            style="padding-left: 30px"
          />
        </CWidgetBrand>
      </CCol>

      <CCol md="4" sm="6">
        <h4><b>Token / NFT User Details</b></h4>
        <CWidgetBrand
          :right-header="this.yesterdaycapture.length"
          :right-footer="this.yesterdaydate"
          :left-header="this.todaycapture.length"
          :left-footer="this.todaydate"
          color="gradient-danger"
        >
          <div class="h4 m-0" style="text-align: center">
            User Capture
            <br />Details
          </div>
          <CIcon
            name="cil-calendar"
            height="52"
            class="my-4"
            style="padding-left: 30px"
          />
        </CWidgetBrand>
      </CCol> -->
    </template>
    <CCol md="12" sm="12">
      <CCard>
        <CCardBody>
          <table style="width: -webkit-fill-available;text-align: center;">
            <tr>
              <th>Asset</th>
              <th colspan="2">Type Captured</th>
              <th colspan="2">Total Qty Captured</th>
              <th colspan="2">Unique Users who Captured</th>
            </tr>
            <tr>
              <th></th>
              <th>{{this.yesterdaydate}}</th>
              <th>{{this.todaydate}}</th>

              <th>{{this.yesterdaydate}}</th>
              <th>{{this.todaydate}}</th>

              <th>{{this.yesterdaydate}}</th>
              <th>{{this.todaydate}}</th>
            </tr>
            <tr>
              <td>NFT</td>
              <td>{{ this.datadisplay.yesterdayTotalnft }}</td>
              <td>{{ this.datadisplay.TodaytotalNFT }}</td>
              <td>{{ this.datadisplay.YesterdayNFT }}</td>
              <td>{{ this.datadisplay.TodayNFT }}</td>
              <td>{{ this.datadisplay.yestercaptureNFT }}</td>
              <td>{{ this.datadisplay.TodayNFT }}</td>
            </tr>

            <tr>
              <td>Token</td>
              <td>{{ this.datadisplay.TodaytotalToken }}</td>
              <td>{{ this.datadisplay.TodaytotalToken }}</td>
              <td>{{ this.datadisplay.yesterdayToken }}</td>
              <td>{{ this.datadisplay.TodayToken }}</td>
              <td>{{ this.datadisplay.yestercaptureToken }}</td>
              <td>{{ this.datadisplay.TodaycaptureToken }}</td>
            </tr>
          </table>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import { CChartLineSimple } from "../charts/index.js";
import moment from "moment";
import firebase from "firebase";
import loader from "vue-ui-preloader";
import Swal from "sweetalert2";
const db = firebase.firestore();
export default {
  name: "WidgetsBrand",
  components: {
    CChartLineSimple,
  },
  props: {
    noCharts: Boolean,
  },
  data() {
    return {
      todaydate: "",
      yesterdaydate: "",

      totaluser: [],
      yesterdayuser: [],
      todayuser: [],
      totalgame: [],
      yesterdaygame: [],
      todaygame: [],
      totaltoken: "",
      totalNFT: "",

      ragecount: "",
      maticount: "",
      Razorcount: "",
      Drakoincount: "",
      CryptoPuzzles: "",
      IndependenceDay: "",
      RageFan_GenShards: "",
      circuit_city: "",
      FinEuro: "",
      AxiInfinite: "",
      ragearray: [],
      matiarray: [],
      razorarray: [],
      drakoinarray: [],
      CryptoPuzzlesarray: [],
      IndependenceDayarray: [],
      RageFan_GenShardsarray: [],
      circuit_cityarray: [],
      FinEuroarray: [],
      AxiInfinitearray: [],

      ragecounttoday: "",
      maticounttoday: "",
      Razorcounttoday: "",
      Drakoincounttoday: "",
      CryptoPuzzlestoday: "",
      IndependenceDaytoday: "",
      RageFan_GenShardstoday: "",
      circuit_citytoday: "",
      FinEurotoday: "",
      AxiInfinitetoday: "",
      ragearraytoday: [],
      matiarraytoday: [],
      razorarraytoday: [],
      drakoinarraytoday: [],
      CryptoPuzzlesarraytoday: [],
      IndependenceDayarraytoday: [],
      RageFan_GenShardsarraytoday: [],
      circuit_cityarraytoday: [],
      FinEuroarraytoday: [],
      AxiInfinitearraytoday: [],

      yesterdaytoken: 0,
      todaytoken: 0,
      yesterdayNFT: 0,
      todayNFT: 0,

      yesterdaycapture: [],
      todaycapture: [],

      ragelength: 0,
      maticlenth: 0,
      Razorlenth: 0,
      Drakoinlength: 0,
      CryptoPuzzleslength: 0,

      IndependenceDaylength: 0,
      RageFan_GenShardslength: 0,
      circuit_citylength: 0,
      FinEurotoday: 0,
      AxiInfinitetoday: 0,

      datadisplay: {},
      ragedata: [],
      ragedatatoday:[],
      yesterdayusernft: [],
      yesterdayusertoken: [],

      todayusernft: [],
      todayusertoken: [],
    };
  },
  mounted(){
  //    window.setInterval(() => {
  // this.datadisplay = JSON.parse(localStorage.getItem("tokenDetails"))
  //          }, 300000);
    
     console.log("datadisplay",  this.datadisplay);
  },

  methods: {
    refresh(){
window.location.reload()
    },
          deleteRoute() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          // text: "You won't be able to revert this!",
          icon: "warning",
          width: "600px",
          showCancelButton: true,
          confirmButtonText: "Yes, Logout!",
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            swalWithBootstrapButtons.fire(
              "success"
            );
            this.logOut();
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire(
              "Cancelled",
              // "Your imaginary file is safe :)",
              
            );
          }
        });
    },
    logOut() {
       const auth = firebase.auth();
      auth.signOut().then(() => {
        localStorage.clear();
        this.$router.push({name:"LoginPage"}
         )
         location.reload();
      })
      .catch(function(error) {
        // An error happened
        alert("Error Occured");
      });
    },
    getuser() {
      db.collection("users")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            this.totaluser.push({
              Id: doc.id,
            });
          });
        });
    },
    checkdate() {
      let today = new Date();
      let yesterday = new Date();

      yesterday.setDate(today.getDate() - 1);

      let v1 = moment(today).format("DD-MMM-YYYY");
      console.log("Today: " + v1);
      let v2 = moment(yesterday).format("DD-MMM-YYYY");
      console.log("yesterday: " + v2);
      db.collection("users")
        .where("created", "!=", null)

        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            let backenddate = moment(doc.data().created.seconds * 1000).format(
              "DD-MMM-YYYY"
            );

            if (backenddate == v1) {
              this.todayuser.push({
                id: doc.id,
              });
            }
            if (backenddate == v2) {
              this.yesterdayuser.push({
                id: doc.id,
              });
            }
          });
        });
    },
    gamepoint() {
      let today = new Date();
      let yesterday = new Date();

      yesterday.setDate(today.getDate() - 1);

      let v1 = moment(today).format("DD-MMM-YYYY");
      let v2 = moment(yesterday).format("DD-MMM-YYYY");
      db.collection("snakeLimitEntry")
        .where("date", "!=", null)

        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            this.totalgame.push({
              id: doc.id,
            });

            let backenddate = moment(
              doc.data().dateObject.seconds * 1000
            ).format("DD-MMM-YYYY");

            if (backenddate == v1) {
              this.todaygame.push({
                id: doc.id,
              });
            }

            if (backenddate == v2) {
              this.yesterdaygame.push({
                id: doc.id,
              });
            }
          });
        });
    },

    gettokens() {
      const db = firebase.firestore();
      db.collection("companyDetails2")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            // if (doc.data().NFT==false) {
            //   this.totaltoken.push({
            //     id: doc.id,
            //   });
            // }else{
            //      this.totalNFT.push({
            //     id: doc.id,
            //   });
            // }
          });
          console.log("this.totalNFT: " + this.totalNFT.length);
        });

      let today = new Date();
      let yesterday = new Date();

      yesterday.setDate(today.getDate() - 1);

      let v1 = moment(today).format("DD-MMM-YYYY");
      let v2 = moment(yesterday).format("DD-MMM-YYYY");

      db.collection("dateWiseRecord")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            for (let i in doc.data()) {
              let backenddate = moment(
                doc.data()[i].Date.seconds * 1000
              ).format("DD-MMM-YYYY");

              if (backenddate == v1) {

                   this.ragedatatoday.push({
                  id: doc.id,
                  Ragecount:
                    doc.data()[i].Rage != undefined
                      ? doc.data()[i].Rage.count
                      : 0,
                  Maticcount:
                    doc.data()[i].Matic != undefined
                      ? doc.data()[i].Matic.count
                      : 0,
                  Razorcount:
                    doc.data()[i].Razor != undefined
                      ? doc.data()[i].Razor.count
                      : 0,
                  Drakoincount:
                    doc.data()[i].Drakoin != undefined
                      ? doc.data()[i].Drakoin.count
                      : 0,
                  CryptoPuzzles:
                    doc.data()[i]["Crypto Puzzles"] != undefined
                      ? doc.data()[i]["Crypto Puzzles"].count
                      : 0,
                  IndependenceDay:
                    doc.data()[i]["75th Indian Independence Day Edition"] !=
                    undefined
                      ? doc.data()[i]["75th Indian Independence Day Edition"]
                          .count
                      : 0,
                  RageFan_GenShards:
                    doc.data()[i]["RageFan+GenShards Partnership NFT"] !=
                    undefined
                      ? doc.data()[i]["RageFan+GenShards Partnership NFT"].count
                      : 0,
                  circuit_city:
                    doc.data()[i]["circuit city"] != undefined
                      ? doc.data()[i]["circuit city"].count
                      : 0,
                  FinEuro:
                    doc.data()[i]["FinEuro"] != undefined
                      ? doc.data()[i]["FinEuro"].count
                      : 0,
                  AxiInfinite:
                    doc.data()[i]["Axi Infinite"] != undefined
                      ? doc.data()[i]["Axi Infinite"].count
                      : 0,
                });

                this.todaycapture.push(doc.id);
                this.ragearraytoday.push(
                  doc.data()[i].Rage != undefined ? doc.data()[i].Rage.count : 0
                );
                this.matiarraytoday.push(
                  doc.data()[i].Matic != undefined
                    ? doc.data()[i].Matic.count
                    : 0
                );
                this.razorarraytoday.push(
                  doc.data()[i].Razor != undefined
                    ? doc.data()[i].Razor.count
                    : 0
                );
                this.drakoinarraytoday.push(
                  doc.data()[i].Drakoin != undefined
                    ? doc.data()[i].Drakoin.count
                    : 0
                );
                this.CryptoPuzzlesarraytoday.push(
                  doc.data()[i]["Crypto Puzzles"] != undefined
                    ? doc.data()[i]["Crypto Puzzles"].count
                    : 0
                );

                //NFT
                this.IndependenceDayarraytoday.push(
                  doc.data()[i]["75th Indian Independence Day Edition"] !=
                    undefined
                    ? doc.data()[i]["75th Indian Independence Day Edition"]
                        .count
                    : 0
                );

                this.RageFan_GenShardsarraytoday.push(
                  doc.data()[i]["RageFan+GenShards Partnership NFT"] !=
                    undefined
                    ? doc.data()[i]["RageFan+GenShards Partnership NFT"].count
                    : 0
                );

                this.circuit_cityarraytoday.push(
                  doc.data()[i]["circuit city"] != undefined
                    ? doc.data()[i]["circuit city"].count
                    : 0
                );

                this.FinEuroarraytoday.push(
                  doc.data()[i]["FinEuro"] != undefined
                    ? doc.data()[i]["FinEuro"].count
                    : 0
                );

                this.AxiInfinitearraytoday.push(
                  doc.data()[i]["Axi Infinite"] != undefined
                    ? doc.data()[i]["Axi Infinite"].count
                    : 0
                );

                this.ragecounttoday = this.ragearraytoday.reduce(function (
                  a,
                  b
                ) {
                  return a + b;
                },
                0);

                this.maticounttoday = this.matiarraytoday.reduce(function (
                  a,
                  b
                ) {
                  return a + b;
                },
                0);

                this.Razorcounttoday = this.razorarraytoday.reduce(function (
                  a,
                  b
                ) {
                  return a + b;
                },
                0);

                this.Drakoincounttoday = this.drakoinarraytoday.reduce(
                  function (a, b) {
                    return a + b;
                  },
                  0
                );

                this.CryptoPuzzlestoday = this.CryptoPuzzlesarraytoday.reduce(
                  function (a, b) {
                    return a + b;
                  },
                  0
                );

                //NFT

                this.IndependenceDaytoday =
                  this.IndependenceDayarraytoday.reduce(function (a, b) {
                    return a + b;
                  }, 0);

                this.RageFan_GenShardstoday =
                  this.RageFan_GenShardsarraytoday.reduce(function (a, b) {
                    return a + b;
                  }, 0);

                this.circuit_citytoday = this.circuit_cityarraytoday.reduce(
                  function (a, b) {
                    return a + b;
                  },
                  0
                );

                this.FinEurotoday = this.FinEuroarraytoday.reduce(function (
                  a,
                  b
                ) {
                  return a + b;
                },
                0);

                this.AxiInfinitetoday = this.AxiInfinitearraytoday.reduce(
                  function (a, b) {
                    return a + b;
                  },
                  0
                );
              }

              if (backenddate == v2) {
                this.yesterdaycapture.push(doc.id);

                this.ragedata.push({
                  id: doc.id,
                  Ragecount:
                    doc.data()[i].Rage != undefined
                      ? doc.data()[i].Rage.count
                      : 0,
                  Maticcount:
                    doc.data()[i].Matic != undefined
                      ? doc.data()[i].Matic.count
                      : 0,
                  Razorcount:
                    doc.data()[i].Razor != undefined
                      ? doc.data()[i].Razor.count
                      : 0,
                  Drakoincount:
                    doc.data()[i].Drakoin != undefined
                      ? doc.data()[i].Drakoin.count
                      : 0,
                  CryptoPuzzles:
                    doc.data()[i]["Crypto Puzzles"] != undefined
                      ? doc.data()[i]["Crypto Puzzles"].count
                      : 0,
                  IndependenceDay:
                    doc.data()[i]["75th Indian Independence Day Edition"] !=
                    undefined
                      ? doc.data()[i]["75th Indian Independence Day Edition"]
                          .count
                      : 0,
                  RageFan_GenShards:
                    doc.data()[i]["RageFan+GenShards Partnership NFT"] !=
                    undefined
                      ? doc.data()[i]["RageFan+GenShards Partnership NFT"].count
                      : 0,
                  circuit_city:
                    doc.data()[i]["circuit city"] != undefined
                      ? doc.data()[i]["circuit city"].count
                      : 0,
                  FinEuro:
                    doc.data()[i]["FinEuro"] != undefined
                      ? doc.data()[i]["FinEuro"].count
                      : 0,
                  AxiInfinite:
                    doc.data()[i]["Axi Infinite"] != undefined
                      ? doc.data()[i]["Axi Infinite"].count
                      : 0,
                });

                // console.log("ragedata",this.ragedata)

                this.ragearray.push(
                  doc.data()[i].Rage != undefined ? doc.data()[i].Rage.count : 0
                );
                this.matiarray.push(
                  doc.data()[i].Matic != undefined
                    ? doc.data()[i].Matic.count
                    : 0
                );
                this.razorarray.push(
                  doc.data()[i].Razor != undefined
                    ? doc.data()[i].Razor.count
                    : 0
                );
                this.drakoinarray.push(
                  doc.data()[i].Drakoin != undefined
                    ? doc.data()[i].Drakoin.count
                    : 0
                );
                this.CryptoPuzzlesarray.push(
                  doc.data()[i]["Crypto Puzzles"] != undefined
                    ? doc.data()[i]["Crypto Puzzles"].count
                    : 0
                );

                //NFT
                this.IndependenceDayarray.push(
                  doc.data()[i]["75th Indian Independence Day Edition"] !=
                    undefined
                    ? doc.data()[i]["75th Indian Independence Day Edition"]
                        .count
                    : 0
                );

                this.RageFan_GenShardsarray.push(
                  doc.data()[i]["RageFan+GenShards Partnership NFT"] !=
                    undefined
                    ? doc.data()[i]["RageFan+GenShards Partnership NFT"].count
                    : 0
                );

                this.circuit_cityarray.push(
                  doc.data()[i]["circuit city"] != undefined
                    ? doc.data()[i]["circuit city"].count
                    : 0
                );

                this.FinEuroarray.push(
                  doc.data()[i]["FinEuro"] != undefined
                    ? doc.data()[i]["FinEuro"].count
                    : 0
                );

                this.AxiInfinitearray.push(
                  doc.data()[i]["Axi Infinite"] != undefined
                    ? doc.data()[i]["Axi Infinite"].count
                    : 0
                );

                this.ragecount = this.ragearray.reduce(function (a, b) {
                  return a + b;
                }, 0);

                this.maticount = this.matiarray.reduce(function (a, b) {
                  return a + b;
                }, 0);

                this.Razorcount = this.razorarray.reduce(function (a, b) {
                  return a + b;
                }, 0);

                this.Drakoincount = this.drakoinarray.reduce(function (a, b) {
                  return a + b;
                }, 0);

                this.CryptoPuzzles = this.CryptoPuzzlesarray.reduce(function (
                  a,
                  b
                ) {
                  return a + b;
                },
                0);

                //NFT

                this.IndependenceDay = this.IndependenceDayarray.reduce(
                  function (a, b) {
                    return a + b;
                  },
                  0
                );

                this.RageFan_GenShards = this.RageFan_GenShardsarray.reduce(
                  function (a, b) {
                    return a + b;
                  },
                  0
                );

                this.circuit_city = this.circuit_cityarray.reduce(function (
                  a,
                  b
                ) {
                  return a + b;
                },
                0);

                this.FinEuro = this.FinEuroarray.reduce(function (a, b) {
                  return a + b;
                }, 0);

                this.AxiInfinite = this.AxiInfinitearray.reduce(function (
                  a,
                  b
                ) {
                  return a + b;
                },
                0);
              }
            }

         
          });
  //  console.log("ragedataone", this.ragedata);
            // console.log("ragedatahere", this.ragedata.length);
            for (let i = 0; i < this.ragedata.length; i++) {
              if (
                this.ragedata[i].AxiInfinite > 0 ||
                this.ragedata[i].FinEuro > 0 ||
                this.ragedata[i].IndependenceDay > 0 ||
                this.ragedata[i].RageFan_GenShards > 0 ||
                this.ragedata[i].circuit_city > 0
              ) {
                this.yesterdayusernft.push(this.ragedata[i].id);
              } else if(this.ragedata[i].Ragecount  > 0 || this.ragedata[i].Maticcount  > 0 || this.ragedata[i].Razorcount  > 0 || this.ragedata[i].Drakoincount  > 0 || this.ragedata[i].CryptoPuzzles  > 0) {
                this.yesterdayusertoken.push(this.ragedata[i].id);
              }
            }



             for (let i = 0; i < this.ragedatatoday.length; i++) {
              if (
                this.ragedatatoday[i].AxiInfinite > 0 ||
                this.ragedatatoday[i].FinEuro > 0 ||
                this.ragedatatoday[i].IndependenceDay > 0 ||
                this.ragedatatoday[i].RageFan_GenShards > 0 ||
                this.ragedatatoday[i].circuit_city > 0
              ) {
                this.todayusernft.push(this.ragedatatoday[i].id);
              } else if(this.ragedatatoday[i].Ragecount  > 0 || this.ragedatatoday[i].Maticcount  > 0 || this.ragedatatoday[i].Razorcount  > 0 || this.ragedatatoday[i].Drakoincount  > 0 || this.ragedatatoday[i].CryptoPuzzles  > 0) {
                this.todayusertoken.push(this.ragedatatoday[i].id);
              }
            }




//             console.log("this.usernft", this.yesterdayusernft);
//  console.log("this.usertoken", this.yesterdayusertoken);
          this.todaytoken =
            this.ragecounttoday +
            this.maticounttoday +
            this.Razorcounttoday +
            this.Drakoincounttoday +
            this.CryptoPuzzlestoday;
          this.yesterdaytoken =
            this.ragecount +
            this.maticount +
            this.Razorcount +
            this.Drakoincount +
            this.CryptoPuzzles;
          this.todayNFT =
            this.IndependenceDaytoday +
            this.RageFan_GenShardstoday +
            this.circuit_citytoday +
            this.FinEurotoday +
            this.AxiInfinitetoday;
          this.yesterdayNFT =
            this.IndependenceDay +
            this.RageFan_GenShards +
            this.circuit_city +
            this.FinEuro +
            this.AxiInfinite;
          //  console.log("this.todaycapture",this.todaycapture, this.todaycapture.length)
          //   console.log("this.yesterdaycapture",this.yesterdaycapture,this.yesterdaycapture.length)
          // console.log("this.IndependenceDaytoday", this.IndependenceDaytoday);
          // console.log(
          //   "this.RageFan_GenShardstoday",
          //   this.RageFan_GenShardstoday
          // );
          // console.log("this.circuit_citytoday", this.circuit_citytoday);
          // console.log("this.FinEurotoday", this.FinEurotoday);
          // console.log("this.AxiInfinitetoday", this.AxiInfinitetoday);

          if (this.ragecounttoday > 0) {
            this.ragelength = 1;
          }
          if (this.maticounttoday > 0) {
            this.maticlenth = 1;
          }
          if (this.Razorcounttoday > 0) {
            this.Razorlenth = 1;
          }
          if (this.Drakoincounttoday > 0) {
            this.Drakoinlength = 1;
          }
          if (this.CryptoPuzzlestoday > 0) {
            this.CryptoPuzzleslength = 1;
          }

          this.totaltoken =
            this.ragelength +
            this.maticlenth +
            this.Razorlenth +
            this.Drakoinlength +
            this.CryptoPuzzleslength;

          if (this.IndependenceDaytoday > 0) {
            this.IndependenceDaylength = 1;
          }
          if (this.RageFan_GenShardstoday > 0) {
            this.RageFan_GenShardslength = 1;
          }
          if (this.circuit_citytoday > 0) {
            this.circuit_citylength = 1;
          }
          if (this.FinEurotoday > 0) {
            this.FinEurotoday = 1;
          }
          if (this.AxiInfinitetoday > 0) {
            this.AxiInfinitetoday = 1;
          }

          this.totalNFT =
            this.IndependenceDaylength +
            this.RageFan_GenShardslength +
            this.circuit_citylength +
            this.FinEurotoday +
            this.AxiInfinitetoday;
        });
    },
    //     refresh(){
    //  window.onload = function () {
    //     if (! localStorage.justOnce) {
    //         localStorage.setItem("justOnce", "true");
    //         window.location.reload();
    //     }
    // }
    //     }
  },
  created() {
    let today = new Date();
    let yesterday = new Date();

    yesterday.setDate(today.getDate() - 1);
    this.todaydate = moment(today).format("DD-MMM-YYYY");
    this.yesterdaydate = moment(yesterday).format("DD-MMM-YYYY");
    this.datadisplay = JSON.parse(localStorage.getItem("tokenDetails"))
      console.log("datadisplay",  this.datadisplay);
  
         window.setInterval(() => {
  this.datadisplay = JSON.parse(localStorage.getItem("tokenDetails"))
           }, 30000);


  },
};
</script>

<style >
table,
th,
td {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 6px;
  font-size: large;
  font-weight: 500;
}
.c-chart-brand {
  position: absolute;
  width: 100%;
  height: 100px;
}
.text-muted {
  color: #768192 !important;
  font-size: large !important;
}

.swal2-cancel {
  margin: 10px !important;
}
</style>


